(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
(function(){
  function init(section){
    if(!section) return;
    var header = section.querySelector('.password-header-overlay');
    if(!header) return;

    var chip = header.querySelector('.password-chip');
    var toggle = header.querySelector('.lock-toggle');
    var contents = header.querySelector('.chip-contents');
    var input = header.querySelector('input[type="password"]');
    var button = header.querySelector('.btn-enter');
    if(!chip || !toggle || !contents) return;

    function openChip(){
      chip.classList.add('is-open');
      toggle.setAttribute('aria-expanded','true');
      contents.setAttribute('aria-hidden','false');
      setTimeout(function(){ if(input) input.focus(); },180);
      document.addEventListener('click',onDocClick,true);
      document.addEventListener('keydown',onKeyDown,true);
    }
    function closeChip(){
      chip.classList.remove('is-open');
      toggle.setAttribute('aria-expanded','false');
      contents.setAttribute('aria-hidden','true');
      document.removeEventListener('click',onDocClick,true);
      document.removeEventListener('keydown',onKeyDown,true);
    }
    function onDocClick(e){ if(!chip.contains(e.target)) closeChip(); }
    function onKeyDown(e){ if(e.key==='Escape'||e.keyCode===27) closeChip(); }

    toggle.addEventListener('click',function(){
      var open=chip.classList.contains('is-open');
      open?closeChip():openChip();
    });

    var submitting = false;
    chip.addEventListener('submit', function(e){
      var val = (input && input.value || '').trim();
      if(!val){
        e.preventDefault();
        openChip();
        toggle.classList.add('shake'); setTimeout(function(){ toggle.classList.remove('shake'); }, 500);
        if(input) input.focus();
        return;
      }
      if(submitting){
        e.preventDefault();
        return;
      }
      submitting = true;
      if(button){ button.disabled = true; button.setAttribute('aria-disabled','true'); }
      setTimeout(function(){
        submitting = false;
        if(button){ button.disabled = false; button.removeAttribute('aria-disabled'); }
      }, 4000);
    });

    if(input && input.getAttribute('aria-invalid') === 'true') {
      openChip();
      input.value = '';
      toggle.classList.add('shake');
      setTimeout(function(){ toggle.classList.remove('shake'); }, 500);
    }
  }

  function initAll(){
    var sections=document.querySelectorAll('.shopify-section.section-password-header');
    for(var i=0;i<sections.length;i++){ init(sections[i]); }
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }

  document.addEventListener('shopify:section:load', function(e){
    if(e.target && e.target.classList && e.target.classList.contains('section-password-header')){
      init(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
